import { v4 as uuid } from 'uuid';

import { Field, OptionList } from './types/basic';
import { RuleCombinator, RuleGroupType, RuleType } from './types/rule';

export const DEFAULT_RULE = {
  field: '',
  operator: '',
  values: [''],
};

export const createEmptyRule = (): RuleType => ({ id: uuid(), ...DEFAULT_RULE });

export const createDefaultCondition = (): RuleGroupType => ({
  combinator: RuleCombinator.AND,
  rules: [createEmptyRule()],
});

export const createFieldMap = (fields: OptionList<Field>) => {
  const map = new Map<string, Field>();
  fields?.forEach((field) => {
    if ('options' in field) {
      field.options?.forEach((subField: Field) => {
        return map.set(subField.value, subField);
      });
    } else {
      map.set(field.value, field);
    }
  });

  return map;
};
